export const dashboardTranslate = {
    es: {
        sidebar: {
            profile:  "Perfil",
            subscrition: "Suscripción",
            payment: "Pagos",
            goto: "Ir a Viva Aerobus"
        },
       
        perfil : {
            exclusive: {
                title: 'Acceso a precios exclusivos',
                subtitle: 'Ahorra hasta $400 mxn en vuelos nacionales y hasta $20 USD en vuelos internacionales.'
            },
            special: {
                title: 'Acceso a ventas especiales',
                subtitle: 'Recibirás ofertas exclusivas por ser Viva Fan.'
            },
            facial: {
                title: 'Reconocimiento facial',
                subtitle: 'Tu proceso de check in y abordaje tan sencillo como sonreír con Smile & Fly.'
            },
            baggage: {
                title: 'Más equipaje',
                subtitle: 'Añade hasta 7kg de equipaje documentado en Smart.'
            },
        },
        terms : 'Ver términos y condiciones',
        facial: {
            title: 'Reconocimiento facial ',
            subtitle: 'Tu proceso de check-in y abordaje será tan sencillo como sonreír con Smile & Fly.',
            linkText : 'Registrarse'
        },
      
        subscription : {
            modify: {
                companions: {
                    title: "Acompañantes en la membresía",
                    subtitle: "Tus acompañantes tendrán acceso al descuento Viva Fan cuando viajen contigo y tendrán la misma vigencia de tu membresía."
                }
            },
            settings : {
                title: 'Ajustes de suscripción',
                subtitle: 'Administra tu membresía Viva Fan.',
                cancel: 'Cancelar renovación',
                activate: 'Activar renovación',
                change: 'Cambiar tipo de membresía',
                modify: 'Modificar acompañantes'
            },
           
        },
        card: {
            accompanied: {
                title: 'Viaja Acompañado',
                plan: 'Plan actual',
                companions: 'Acompañantes',
                companionsText: 'acompañante',
                typeofPayment: 'Tipo de pago',
                qouta: 'Cuota',
                qoutaRenewal: 'Cuota renovación',

                since : 'Miembro desde',
                renewal: 'Renovación automática',
                monthly: 'Mensual',
                annual: 'Anual'
            },
            payment: {
                title: 'Método de pago',
                cardNumber : "Tarjeta",
                expiration: "Expiración",
                billsTitle: 'Bills',
                billsSubtitle: 'Para facturar, manda correo a vivafan@vivaaerobus.com',
                paymentHistoryTitle: 'Historial de pagos',  
                paymentType: "Viaja acompañado",
                noInvoice: "Historial de pagos No hay historial de facturas"
            },
            
        },
        billing: {
            title: 'Datos de facturación',
            empty: 'Asegúrate de que tus datos sean iguales a los de tu CFDI',
            add: 'Agregar',
            name: 'Nombre',
            cardType: 'Tipo de tarjeta',
            card: 'Tarjeta',
            zipCode: 'Código Postal', 
            cancel: 'Cancelar',
            regimen: 'Régimen',
            edit: 'Editar',
            clave: 'Clave',
            save: 'Guardar',
            requestInvoice: 'Solicitar factura',
            downloadInvoice: 'Descargar factura',
            successTitle: 'Datos de facturación',
            successDescription: 'Tus datos se guardaron exitosamente',
            select: 'Selecciona un ',
            isRequired: 'es requerido'
        },
        payment : {
            bills: {
                invoice : {
                    title: "Facturas",
                    subtitle: "Para facturar, envía un correo a vivafan@vivaaerobus.com."
                }
            }
        },
        promotions: {
            headerTitle: "Promociones y eventos",
            title :  `Obtén recompensas por cada referido`,
            subtitle: `Recibe hasta $100 de crédito en Viva Cash por cada amigo referido. Comparte el siguiente enlace para que tú y tus amigos disfruten de grandes beneficios.`
        },
        promotionsBest: {
            title:'Las mejores promociones con Viva Fan',
            subtitle: 'Encuentra los precios especiales y promociones exclusivas a las que tienes acceso con tu membresía.',
            see: 'Ver Más'

        },
     
        information: {
            text: 'Para más información y soporte, envia un correo a',
            email: 'vivafan@vivaaerobus.com'
        },
      
    },
    eng : {
        sidebar: {
            profile:  "Profile",
            subscrition: "Subscription",
            payment: "Payments",
            goto: "Go to Viva Aerobus"
        },
        perfil : {
            exclusive: {
                title: 'Access to exclusive prices',
                subtitle: 'Save up to $400 mxn on domestic flights and up to $20 USD on international flights.'
            },
            special: {
                title: 'Access to special sales',
                subtitle: 'You will receive exclusive offers for being a Viva Fan.'
            },
            facial: {
                title: 'Face recognition',
                subtitle: 'Your check-in and boarding process as easy as smiling with Smile & Fly.'
            },
            baggage: {
                title: 'More luggage included',
                subtitle: 'Up to 7kg of checked luggage in SMART.'
            },
        },
        terms : 'See terms and conditions',
        facial: {
            title: 'Face recognition ',
            subtitle: 'Your check-in and boarding process as easy as smiling with Smile & Fly.',
            linkText : 'Check in'
        },
        subscription : {
            modify: {
                companions: {
                    title: "Companions in the membership",
                    subtitle: "Your companions will have access to the Viva Fan discount when they travel with you and will have the same validity as your membership."
                }
            },
            settings : {
                title: 'Subscription settings',
                subtitle: 'Manage your Viva Fan membership.',
                cancel: 'Cancel renewal',
                activate: 'Activate renewal',
                change: 'Change membership type',
                modify: 'Modify Companions'
            }
        },
        card: {
          
            accompanied: {
                title: 'Travel Accompanied',
                plan: 'Current plan',
                companions: 'Companions',
                companionsText: 'companion',
                typeofPayment: 'Payment type',
                qouta: 'Share',
                qoutaRenewal : 'Share Renewal',

                since : 'Member since',
                renewal: 'Automatic renewal',
                monthly: 'Monthly',
                annual: 'Annualy',
                noInvoice: "No invoice history"

            },
            payment: {
                title: 'Payment method',
                cardNumber : "Card",
                expiration: "Expiration",
                billsTitle: 'Bills',
                billsSubtitle: 'To bill, send an email to vivafan@vivaaerobus.com',
                paymentHistoryTitle: 'Payment history',  
                paymentType: "Travel accompanied",
                noInvoice: "No invoice history"

            },
        },
        promotions: {
            headerTitle: 'Promotions and events',
            title: `$100 MXN for each referred friend`,
            subtitle: `Receive up to $100 MXN in Viva Cash for every friend you refer. Share your link so that you and your friends enjoy great benefits.`
        },
        promotionsBest: {
            title:'The best promotions with Viva Fan',
            subtitle: 'Find the special prices and exclusive promotions to which you have access with your membership.',
            see: 'See more'
        },
        information: {
            text: 'For more information and support, send an email to',
            email: 'vivafan@vivaaerobus.com'
        },
        payment : {
            bills: {
                invoice : {
                    title: "Bills",
                    subtitle: "To invoice, send an email to vivafan@vivaaerobus.com."
                }
            }
        },
        billing: {
            title: 'Billing information',
            empty: 'Make sure your data is the same as your CFDI',
            add: 'Add',
            name: 'Name',
            card: 'Card',
            cardType: 'Card Type',
            zipCode: 'Postal Code', 
            regimen: 'Regime',
            cancel: 'Cancel',
            clave: 'Key',
            edit: 'Edit',
            save: 'Save',
            requestInvoice: 'Request invoice',
            downloadInvoice: 'Download invoice',
            successTitle: 'Billing information',
            successDescription: 'Your data was saved successfully',
            select: 'Select',
            isRequired: 'is required'

        },
    }
}